<template>
  <div v-if="!loading" class="tracking">
    <div class="tracking__container text-primary">
      <!-- Header -->
      <div class="w-full pt-8">
        <a href="/dashboard">
          <img
            width="155"
            src="@/assets/img/Dashboard/logo-azul-sin-fondo.png"
            alt=""
          />
        </a>
      </div>
      <!-- Body -->
      <div class="w-full mt-6 flex flex-col md:flex-row">
        <!-- First col -->
        <div class="w-full md:w-1/2 md:mr-4 flex flex-col">
          <div>
            <span class=" tracking__title"
              >Seguimiento <br />
              de tu pedido</span
            >
          </div>
          <br />
          <br />
          <br />
          <div class="bg-white lg:w-1/3 w-full flex justify-center py-2">
            <span class=" text-lg">
              ID Pedido: {{ tracking && tracking.order.orderId }}
            </span>
          </div>
          <div v-if="tracking && tracking.order.status != 'canceled'">
            <div class="my-3">
              <h3 class=" lg:text-left text-center">
                ¡Hola {{ tracking && tracking.point.contact.name }}!
              </h3>
            </div>
            <div class=" lg:text-left text-center">
              <span>Aquí verás el estado de tu pedido de:</span>
              <span class="font-neue ml-2">{{
                tracking && tracking.order.company.company.name
              }}</span>
            </div>
            <div class=" text-lg mt-2 lg:text-left text-center">
              <span>Rider:</span>
              <span v-if="tracking.order.partner" class="font-neue ml-2">{{
                tracking &&
                `${tracking.order.partner.user.name.first} ${tracking.order.partner.user.name.last}`
              }}</span>
            </div>
            <div class=" text-lg mt-2 lg:text-left text-center">
              <span>Teléfono:</span>
              <span v-if="tracking.order.partner" class="font-neue ml-2">{{
                tracking && tracking.order.partner.phone
              }}</span>
            </div>
          </div>
          <div v-else class="flex flex-col gap-2 mt-5">
            <div>
              <h3 class=" lg:text-left text-center">
                ¡Hola {{ tracking && tracking.point.contact.name }}!
              </h3>
            </div>
            <div class=" lg:text-left text-center">
              <span>Tu pedido ha sido <strong>cancelado</strong> por</span>
              <span class="font-neue ml-2">{{
                tracking && tracking.order.company.company.name
              }}</span>
            </div>
            <div class=" lg:text-left text-center">
              <span
                >Para saber más sobre la cancelación, contacta con el
                proveedor.</span
              >
            </div>
            <div class="w-full flex lg:justify-start justify-center mt-5">
              <img
                style="width: 50%; max-width: 128px"
                src="@/assets/img/Icons/cajita_grande.png"
                alt="cajita"
              />
            </div>
          </div>

          <!-- Tracking -->
          <div
            v-if="tracking && tracking.order.status != 'canceled'"
            class="stepper-wrapper"
          >
            <div
              v-for="(step, index) in steps"
              :key="index"
              class="stepper-item"
            >
              <div class="step-counter">
              <!--
                <img
                  v-if="index === 3 && step.state === 'No entregado'"
                  class="tracking__img2"
                  :src="require(`@/assets/img/tracking/${step.img3}`)"
                  alt="tracking-step-3"
                />
                <img
                  v-else-if="index < currentStep + 1"
                  class="tracking__img2"
                  :src="require('@/assets/img/tracking/check.png')"
                  alt="step"
                />
                <img
                  v-else
                  class="tracking__icon"
                  :src="require(`@/assets/img/tracking/${step.img}`)"
                  alt="step"
                />
                -->
                {{index + 1}}
              </div>
              <div
                v-if="index <= currentStep"
                class="step-name mt-1 flex items-center justify-center"
              >
                <span class="progress__label"> {{ step.label }} </span>
              </div>
              <div
                v-if="index > currentStep"
                class="step-name mt-1 flex items-center justify-center"
              >
                <span class="progress__label2"> {{ step.label }} </span>
              </div>
              <div class="flex items-center justify-center">
                <p
                  v-if="index <= currentStep + 1"
                  class="progress__description"
                >
                  {{ step.description }}
                </p>
              </div>
            </div>
          </div>
          <!-- /Tracking-mobile -->
          <div
            v-if="tracking && tracking.order.status != 'canceled'"
            class="w-full flex flex-wrap items-center gap-4 lg:hidden block my-6"
          >
            <div
              v-for="(step, index) in steps"
              :key="index"
              class="w-full flex items-center"
            >
              <div class="step__responsive mr-4">
                <img
                  v-if="index === 3 && step.state === 'No entregado'"
                  class="tracking__img"
                  :src="require(`@/assets/img/tracking/${step.img3}`)"
                  alt="step"
                />
                <img
                  v-else-if="index < currentStep + 1"
                  class="tracking__img"
                  :src="require('@/assets/img/tracking/check.png')"
                  alt="step"
                />
                <img
                  v-else
                  class="tracking__img"
                  :src="
                    require(`@/assets/img/tracking/${
                      index <= currentStep + 1 ? step.img2 : step.img
                    }`)
                  "
                  alt="step"
                />
              </div>
              <div class="flex flex-col gap-1 ">
                <span v-if="index <= currentStep + 1" class="font-bold">
                  {{ step.label }}
                </span>
                <span v-if="index <= currentStep + 1" class="text-sm">
                  {{ step.description }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Second col -->
        <div
          v-if="tracking && tracking.order.status != 'canceled'"
          class="w-full md:w-1/2 md:mr-4 flex flex-col"
          style="z-index: 3"
        >
          <div class="bg-primary w-full px-8 pt-8">
            <div class="flex">
              <div class="text-white flex flex-col text-xl">
                <span class="font-neue text-2xl mb-2">¿Quien recibió?</span>
                <span v-if="tracking.point.chargeReceivedBy">{{
                  tracking.point.chargeReceivedBy
                }}</span>
                <span v-else>-</span>
              </div>
            </div>
            <div class="flex mt-4 mb-8">
              <div class="text-white flex flex-col text-xl">
                <span class="font-neue text-2xl mb-2">Detalle:</span>
                <span v-if="tracking.point.descriptionPoint">{{
                  tracking.point.descriptionPoint
                }}</span>
                <span v-else>-</span>
              </div>
            </div>
          </div>
          <div
            style="background-color: #f1f1f1; height: 50vh"
            class="flex justify-center items-center"
          >
            <img
              v-if="tracking.point.chargePointImage"
              class="evidence"
              :src="tracking.point.chargePointImage"
              alt="cargando"
            />
            <em
              v-else
              class="el-icon-picture-outline  text-xl"
            />
          </div>
        </div>
      </div>
      {{ order }}
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import io from "socket.io-client";
export default {
  props: {
    id: String,
    back: {
      type: String,
      default: "/tracking",
    },
  },
  data() {
    return {
      currentStep: 0,
      type: "vertical",
      loading: false,
      evidence: false,
      socket: io(),
      status: {
        confirmed: 0,
        pending: -1,
        sending: 1,
        Entregado: 3,
      },
      steps: [
        {
          label: "PEDIDO CONFIRMADO",
          description: "Se está preparando tu pedido.",
          img: "dev.svg",
          img2: "dev2.svg",
        },
        {
          label: "SE RECOGIÓ TU PEDIDO",
          description: "",
          img: "get.png",
          img2: "get2.svg",
        },
        {
          label: "YA ESTAMOS EN CAMINO",
          description: "Rango de llegada de 9am a 7pm",
          img: "way.png",
          img2: "way2.svg",
        },
        {
          label: "PAQUETE ENTREGADO",
          description: "",
          state: "",
          img: "done.png",
          img2: "done2.svg",
          img3: "noget.png",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["tracking"]),
    order() {
      if (this.tracking && this.tracking.order) {
        this.currentStep = this.status[this.tracking.order.status];
        if (
          this.tracking.order.dateArrived &&
          this.tracking.order.dateArrived !== ""
        ) {
          this.currentStep = 1;
          this.steps[1].description = `El ${moment(
            this.tracking.order.dateArrived
          ).format("DD/MM/YYYY")} a las ${moment(
            this.tracking.order.dateArrived
          ).format("hh:mm")} `;
        }
        if (this.tracking.point.statePoint !== "") {
          this.currentStep = 3;
          this.steps[3].description = `El ${moment(
            this.tracking.point.done
          ).format("DD/MM/YYYY")} a las ${moment(
            this.tracking.point.done
          ).format("hh:mm")} pm `;
          this.steps[3].state = this.tracking.point.statePoint;
          if (this.steps[3].state !== "Entregado") {
            this.steps[3].label = "PAQUETE NO ENTREGADO";
          }
        }
      }
      return "";
    },
  },
  async mounted() {
    this.loading = true;
    const id = this.$route.query.order;
    this.$store.commit("STORE_ID_ORDER", id);
    await this.getTracking(id);
    this.currentStep = this.status[this.tracking.order.status];
    if (
      this.tracking.order.dateArrived &&
      this.tracking.order.dateArrived !== ""
    ) {
      this.currentStep = 1;
      this.steps[1].description = `El ${moment(
        this.tracking.order.dateArrived
      ).format("DD/MM/YYYY")} a las ${moment(
        this.tracking.order.dateArrived
      ).format("hh:mm")} `;
    }
    if (this.tracking.point.statePoint !== "") {
      this.currentStep = 3;
      this.steps[3].description = `El ${moment(this.tracking.point.done).format(
        "DD/MM/YYYY"
      )} a las ${moment(this.tracking.point.done).format("hh:mm")} pm `;
      this.steps[3].state = this.tracking.point.statePoint;
      if (this.steps[3].state !== "Entregado") {
        this.steps[3].label = "PAQUETE NO ENTREGADO";
      }
    }
    this.loading = false;
  },
  methods: {
    ...mapActions(["getTracking"]),
    showEvidence() {
      this.evidence = true;
      document.getElementById("evidence").scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tracking__container {
  max-width: 1360px;
  margin: 0 auto;

  @media only screen and (max-width: 1361px) {
    padding: 0 8%;
  }
}

.tracking__title {
  font-size: 55px;

  @media only screen and (max-width: 992px) {
    font-size: 40px;
  }
}

.tracking__img {
  width: 100%;
}

.logo {
  width: 400px;
  height: auto;
  object-fit: cover;
}

.cancel {
  width: 150px;
  height: auto;
  object-fit: cover;
}

.evidence {
  width: 300px;
  height: 300px;
  object-fit: contain;
}

.tracking__img2 {
  width: 100%;
  max-width: 400%;
  object-fit: contain;
}

.progress__label {
  font-weight: bolder;
  font-size: 16px;
  padding-left: 10px;
  text-decoration: underline;
}

.progress__label2 {
  font-weight: 600;
  font-size: 16px;
  padding-left: 10px;
}

.tracking__icon {
  width: 60%;
}

.progress__description {
  font-size: 14px;
  padding-left: 10px;
  padding-bottom: 30px;
}

/* pther example */
.stepper-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 1vh;

  @media only screen and (min-width: 1400px) {
    margin-top: 16vh;
  }
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 68px;
  border: 2px solid gray;
  background: white;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed .step-counter {
  background-color: #084c71;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #084c71;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}

.stepper-item:last-child::after {
  content: none;
}

/* step 2 */

.step__responsive {
  height: 50px;
  width: 50px;
  border: 2px solid #73c9ff;
  transition: all 1000ms ease;
}

ul {
  margin-top: 20px;
  display: none;
}

li {
  list-style: none;
  line-height: 1px;
}

h5 {
  font-size: 23px;
}

@media (max-width: 992px) {
  .stepper-wrapper {
    display: none;
  }

  h5 {
    font-size: 15px;
  }
}
</style>
